<template>
  <div>
    <b-row>
      <b-col class="" cols="12" md="3">
        <b-card class="mb-0 h-100 tree-container" no-body>
          <div class="left-tree">
            <v-jstree
                :data="treeData"
                :show-checkbox="false"
                allow-batch
                icons="false"
                multiple
                no-dots
                whole-row
                @item-click="itemClick"
            >
              <template scope="_">
                <div
                    :class="selectedReportId === _.model.Id ? 'selected-report' : ''"
                    style="display: inherit; width: 200px"
                    @contextmenu.prevent="$refs.ctx.open($event, _.vm)"
                >
                  {{ _.model.Name }}
                </div>
              </template>
            </v-jstree>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" md="9">
        <b-card v-if="filterDetail.length > 0" class="mb-0" no-body>
          <validation-observer ref="modalEdit">
            <div class="p-1">
              <b-row>
                <b-col v-for="(filter, index) in filterDetail" cols="12" md="4">
                  <validation-provider
                      v-if="filter.Type === 'D'"
                      #default="{ errors }"
                      :name="filter.Name"
                      :rules="filter.Required ? 'required' : ''"
                  >
                    <b-form-group :label="filter.Name">
                      <b-input-group :label="filter.Name">
                        <b-form-datepicker
                            v-model="filter.value"
                            :date-format-options="{
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric',
                          }"
                            :state="errors.length > 0 ? false : null"
                            close-button
                            locale="vi-VN"
                            reset-button
                            today-button
                        />
                      </b-input-group>
                      <div class="error-txt">
                        <small v-if="errors.length > 0"
                        >{{ filter.Name }} không được để trống</small
                        >
                      </div>
                    </b-form-group>
                  </validation-provider>
                  <validation-provider
                      v-if="filter.Type === 'C'"
                      #default="{ errors }"
                      :name="filter.Name"
                      :rules="filter.Required ? 'required' : ''"
                  >
                    <b-form-group :label="filter.Name">
                      <Select2
                          v-model="filter.value"
                          :options="filter.Options"
                          :state="errors.length > 0 ? false : null"
                      />
                      <div class="error-txt">
                        <small v-if="errors.length > 0"
                        >{{ filter.Name }} không được để trống</small
                        >
                      </div>
                    </b-form-group>
                  </validation-provider>
                  <validation-provider
                      v-if="filter.Type === 'T'"
                      #default="{ errors }"
                      :name="filter.Name"
                      :rules="filter.Required ? 'required' : ''"
                  >
                    <b-form-group :label="filter.Name">
                      <b-form-input v-model="filter.value"/>
                      <div class="error-txt">
                        <small v-if="errors.length > 0"
                        >{{ filter.Name }} không được để trống</small
                        >
                      </div>
                    </b-form-group>
                  </validation-provider>
                  <validation-provider
                      v-if="filter.Type === 'R'"
                      #default="{ errors }"
                      :name="filter.Name"
                      :rules="filter.Required ? 'required' : ''"
                  >
                    <b-form-group :label="filter.Name">
                      <div style="display: flex; width: 100%">
                        <b-form-radio
                            v-for="r in filter.Options"
                            v-model="filter.value"
                            :value="r.id"
                            style="margin-bottom: 5px; margin-right: 25px"
                        >{{ r.text }}
                        </b-form-radio
                        >
                      </div>
                      <div class="error-txt">
                        <small v-if="errors.length > 0"
                        >{{ filter.Name }} không được để trống</small
                        >
                      </div>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
            </div>
          </validation-observer>
        </b-card>
        <div class="p-1 text-center">
          <b-button variant="primary" @click="clearReport">
            Xoá trắng
          </b-button>
          <b-button class="ml-1" variant="primary" @click="printDetail"
          >Xem báo cáo
          </b-button
          >
          <b-button class="ml-1" variant="secondary" @click="exportExcel"
          >Xuất file Excel
          </b-button>
          <b-button class="ml-1" variant="secondary" @click="exportExcel2"
          >Xuất dữ liệu thô
          </b-button>
        </div>
        <b-row>
          <b-col cols="12" md="12">
            <vue-pdf-app
                v-if="isHaveData == 0"
                :fileName="currentItem.fileName"
                :pdf="pdf"
                class="rounded"
                pageScale="60"
                style="height: calc(100vh - 225px)"
            ></vue-pdf-app>
            <vue-pdf-app
                v-else-if="isHaveData == 1"
                :fileName="currentItem.fileName"
                :pdf="pdf"
                class="rounded"
                pageScale="60"
                style="height: calc(100vh - 225px)"
            ></vue-pdf-app>
            <div v-else class="rounded" pageScale="60" style="height: 85vh">
              Không có dữ liệu
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormSelect,
  BInputGroup,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip,
  VBTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import moment from "moment";
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";
import VJstree from "vue-jstree";
import {required} from '@validations'
extend("laisuat", (value) => {
  if ((value + "").indexOf(".") < 0) {
    return true;
  }
  return (value + "").split(".")[1].length <= 2;
});

export default {
  components: {
    VuePdfApp,
    BInputGroup,
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    VJstree,
    BFormRadio,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  created() {
    this.getTreeData();
  },
  watch: {
    $route(to, from) {
      this.pdf = null;
    },
  },
  data() {
    return {
      currentItem: {attribute: {}},
      isHaveData: 0,
      pdf: null,
      statusList: [
        {id: -1, text: "Tất cả các trạng thái"},
        {id: 0, text: "Chưa thanh toán"},
        {id: 1, text: "Đã thanh toán/Chờ xác nhận"},
        {id: 2, text: "Đã xác nhận/Chuyển vận đơn"},
        {id: 3, text: "Hoàn thành giao hàng"},
        {id: 90, text: "Lỗi thanh toán"},
        {id: 91, text: "Trả hàng"},
      ],
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50,
      },
      treeData: [],
      filterDetail: [],
      selectedReportId: null,
      required
    };
  },
  methods: {
    clearReport() {
      this.pdf = null;
      this.selectedReportId = null;
      this.filterDetail = [];
    },
    async printDetail(row) {
      var validate = true;
      if (this.$refs.modalEdit) {
        validate = await this.$refs.modalEdit.validate().then((success) => {
          return success;
        });
      }
      if (!validate || this.selectedReportId === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra dữ liệu!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      this.loading(true);

      const params = {};
      for (const item of this.filterDetail) {
        if (item.Type === "D") {
          params[item.Code] = moment(item.value).format("YYYY-MM-DD");
        } else if (item.Type === "T") {
          params[item.Code] = item.value;
        } else if (item.Type === "R") {
          params[item.Code] = item.value;
        } else if (item.Type === "C") {
          params[item.Code] = item.value;
        }
      }

      useJwt
          .post(
              "rpt/export",
              {
                ReportId: this.selectedReportId,
                FileType: "pdf",
                Parameters: params,
              },
              {responseType: "arraybuffer"}
          )
          .then((response) => {
            this.pdf = response.data;
            this.loading(false);
          })
          .catch((error) => {
            this.loading(false);
          });
    },
    async exportExcel(row) {
      var validate = true;
      if (this.$refs.modalEdit) {
        validate = await this.$refs.modalEdit.validate().then((success) => {
          return success;
        });
      }
      if (!validate || this.selectedReportId === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra dữ liệu!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      this.loading(true);

      const params = {};
      for (const item of this.filterDetail) {
        if (item.Type === "D") {
          params[item.Code] = moment(item.value).format("YYYY-MM-DD");
        } else if (item.Type === "T") {
          params[item.Code] = item.value;
        } else if (item.Type === "R") {
          params[item.Code] = item.value;
        } else if (item.Type === "C") {
          params[item.Code] = item.value;
        }
      }

      useJwt
          .post(
              "rpt/export",
              {
                ReportId: this.selectedReportId,
                FileType: "xls",
                Parameters: params,
              },
              {responseType: "arraybuffer"}
          )
          .then((response) => {
            const a = document.createElement("a");
            a.href = URL.createObjectURL(
                new Blob([response.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            );
            a.download = "report_" + moment().format("YYYY-MM-DD") + ".xlsx";
            a.click();
            this.loading(false);
          })
          .catch((error) => {
            this.loading(false);
          });
    },
    async exportExcel2(row) {
      var validate = true;
      if (this.$refs.modalEdit) {
        validate = await this.$refs.modalEdit.validate().then((success) => {
          return success;
        });
      }
      if (!validate || this.selectedReportId === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra dữ liệu!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      this.loading(true);

      const params = {};
      for (const item of this.filterDetail) {
        if (item.Type === "D") {
          params[item.Code] = moment(item.value).format("YYYY-MM-DD");
        } else if (item.Type === "T") {
          params[item.Code] = item.value;
        } else if (item.Type === "R") {
          params[item.Code] = item.value;
        } else if (item.Type === "C") {
          params[item.Code] = item.value;
        }
      }

      useJwt
          .post(
              "rpt/export_excel",
              {
                ReportId: this.selectedReportId,
                FileType: "xls",
                Parameters: params,
              },
              {responseType: "arraybuffer"}
          )
          .then((response) => {
            const a = document.createElement("a");
            a.href = URL.createObjectURL(
                new Blob([response.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            );
            a.download = "report_" + moment().format("YYYY-MM-DD") + ".xlsx";
            a.click();
            this.loading(false);
          })
          .catch((error) => {
            this.loading(false);
          });
    },
    // new handle
    async getTreeData() {
      this.loading(true);
      const rs = await useJwt.get("rpt/list");
      this.treeData = [];

      if (rs && rs.data && rs.data.result) {
        const childs = [
          ...rs.data.result.map((item) => {
            return {
              ...item,
              children: [],
              opened: false,
            };
          }),
        ];

        for (let i = 0; i < childs.length; i++) {
          if (!childs[i].ParentId) {
            this.treeData.push(childs[i]);
          } else {
            const parent = childs.find((item) => item.Id === childs[i].ParentId);
            parent.children.push(childs[i]);
          }
        }
      }
      this.loading(false);
    },
    async itemClick(node, item, e) {
      if (this.selectedReportId !== item.Id) {
        this.loading(true);
        this.selectedReportId = item.Id;
        await this.getDetailData();
        this.loading(false);
      }
    },
    async getDetailData() {
      if (this.selectedReportId === null) return;

      this.filterDetail = [];
      const rs = await useJwt.get(`rpt/detail/${this.selectedReportId}`);
      if (rs && rs.data && rs.data.result) {
        this.filterDetail = rs.data.result.map((item) => ({
          ...item,
          value: item.Options && item.Options[0] ? item.Options[0].id : "",
        }));
      }
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.error-txt small {
  color: red;
}

.tree-container {
  height: 100%;
  position: relative;
  overflow: hidden;
}

.left-tree {
  position: absolute;
  top: 0;
  left: 0;
  overflow: scroll;
  width: 100%;
  height: 100%;
  padding: 10px;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    border: 13px solid #d7d7d7;
  }

  &::-webkit-scrollbar-track {
    background: white;
  }

  &::-webkit-scrollbar-thumb {
    background: #e7e7e7;
    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #d7d7d7;
    cursor: pointer;
  }

  .selected-report {
    width: 100% !important;
    background-color: #dfdfdf !important;
  }

  .tree-default .tree-anchor,
  .tree-default .tree-icon,
  .tree-default .tree-disabled {
    color: #000 !important;
    font-size: 15px;
    font-weight: bold;
  }

  .tree-disabled .tree-checkbox {
    display: none !important;
  }
}
</style>
